import { useCallback } from 'react';
import useUsers from '../context/UsersContext';
import appService from '../service/app.service';

const pendingSavesByUser = new Map();
const latestViewsByUser = new Map();

const useSaveView = (user) => {
  const { updateViews } = useUsers();

  const saveView = useCallback(
    async (viewName, newViewObj) => {
      if (user && Object.keys(user).length > 0) {
        const storedUser = JSON.parse(localStorage.getItem('user') ?? 'null');
        const persistedViews = storedUser?.userId === user.userId ? storedUser.views : user.views;
        const latestViews = latestViewsByUser.get(user.userId) ?? persistedViews ?? {};
        const currentViews = latestViews?.[viewName] || {};
        const updatedView = {
          ...currentViews,
          ...newViewObj,
        };
        if (JSON.stringify(currentViews) === JSON.stringify(updatedView)) return;

        const newViews = { ...latestViews, [viewName]: updatedView };
        const viewsStringified = JSON.stringify(newViews);

        latestViewsByUser.set(user.userId, newViews);

        const previousSave = pendingSavesByUser.get(user.userId) ?? Promise.resolve();
        const currentSave = previousSave
          .catch(() => undefined)
          .then(() => appService.updateUserView({ views: viewsStringified }, user.userId));
        pendingSavesByUser.set(user.userId, currentSave);

        try {
          await currentSave;
          if (pendingSavesByUser.get(user.userId) === currentSave) {
            updateViews(latestViewsByUser.get(user.userId) ?? newViews);
            pendingSavesByUser.delete(user.userId);
            latestViewsByUser.delete(user.userId);
          }
          return true;
        } catch {
          if (pendingSavesByUser.get(user.userId) === currentSave) {
            pendingSavesByUser.delete(user.userId);
          }
          return false;
        } finally {
          if (pendingSavesByUser.get(user.userId) === currentSave) pendingSavesByUser.delete(user.userId);
        }
      }
      return false;
    },
    [user, updateViews]
  );

  return saveView;
};

export default useSaveView;
